import { useNavigate } from "react-router-dom";
import { B, fonts, NilamLogo } from "./UI";
import { withCloudinaryLogoOptimization } from "../utils/cloudinary";

export default function SiteFooter({ branding, categories = [] }) {
  const navigate = useNavigate();
  const accent = branding.primaryColor || B.orange;

  const whatsappLink = branding.whatsapp
    ? `https://wa.me/${branding.whatsapp.replace(/\D/g, "")}?text=Hi! I'm interested in your kurti collection.`
    : null;

  return (
    <footer style={{ background: "white", color: B.textMid, padding: "40px 24px 32px", marginTop: 10, borderTop: `1px solid ${B.borderLight}` }}>
      <div style={{ maxWidth: 1280, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: 40, marginBottom: 40 }}>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
              <NilamLogo size={36} logoUrl={withCloudinaryLogoOptimization(branding.logoUrl)} />
              <span style={{ fontFamily: fonts.display, fontSize: 18, fontWeight: 700, color: accent }}>{branding.brandName}</span>
            </div>
            <p style={{ fontSize: 13, lineHeight: 1.7, color: B.textMid, fontFamily: fonts.body }}>{branding.tagline}</p>
            <p style={{ fontSize: 12, color: B.textLight, marginTop: 10, fontFamily: fonts.body }}>{branding.address}</p>
          </div>

          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", color: accent, marginBottom: 14, fontFamily: fonts.body }}>Categories</div>
            {categories.length > 0 ? categories.map(cat => (
              <div key={cat.id} onClick={() => navigate(`/category/${cat.slug}`)}
                style={{ fontSize: 13, color: B.textMid, cursor: "pointer", marginBottom: 8, fontFamily: fonts.body, transition: "color 0.2s" }}
                onMouseEnter={e => e.target.style.color = accent}
                onMouseLeave={e => e.target.style.color = B.textMid}>
                {cat.name}
              </div>
            )) : (
              <div style={{ fontSize: 13, color: B.textLight, fontFamily: fonts.body }}>New categories coming soon</div>
            )}
          </div>

          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", color: accent, marginBottom: 14, fontFamily: fonts.body }}>Info</div>
            {[
              ["About Us", "/about"],
              ["How To Order", "/how-to-order"],
              ["Kurti Manufacturer Ahmedabad", "/kurti-manufacturer-ahmedabad"],
              ["Wholesale Kurtis Ahmedabad", "/wholesale-kurtis-ahmedabad"],
              ["Cotton Kurtis Manufacturer", "/cotton-kurtis-manufacturer"],
              ["Designer Kurtis Wholesale", "/designer-kurtis-wholesale"],
            ].map(([label, path]) => (
              <div key={path} onClick={() => navigate(path)}
                style={{ fontSize: 13, color: B.textMid, cursor: "pointer", marginBottom: 8, fontFamily: fonts.body }}
                onMouseEnter={e => e.target.style.color = accent}
                onMouseLeave={e => e.target.style.color = B.textMid}>
                {label}
              </div>
            ))}
          </div>

          <div>
            <div style={{ fontSize: 10, fontWeight: 700, letterSpacing: "0.15em", textTransform: "uppercase", color: accent, marginBottom: 14, fontFamily: fonts.body }}>Contact</div>
            {branding.phone && <p style={{ fontSize: 13, color: B.textMid, marginBottom: 8, fontFamily: fonts.body }}>📞 {branding.phone}</p>}
            {whatsappLink && (
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer"
                style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "#25D366", color: "#fff", padding: "8px 16px", borderRadius: 8, fontSize: 12, fontWeight: 600, textDecoration: "none", fontFamily: fonts.body }}>
                💬 WhatsApp Us
              </a>
            )}
          </div>
        </div>

        <div style={{ borderTop: `1px solid ${B.border}`, paddingTop: 24, display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 10 }}>
          <p style={{ fontSize: 11, color: B.textLight, fontFamily: fonts.body }}>© {new Date().getFullYear()} {branding.brandName} · All rights reserved</p>
          <p style={{ fontSize: 11, color: B.textLight, fontFamily: fonts.body }}>
            Handcrafted with ❤️ by{" "}
            <a
              href="https://priyesh-doshi.carrd.co/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: B.textLight, textDecoration: "underline" }}
            >
              Priyesh
            </a>{" "}
            in Ahmedabad
          </p>
        </div>
      </div>
    </footer>
  );
}
